// src/components/eventos/components/operacional/EventoAtivoCard.js
import React from 'react';

const CalendarIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
);
const ClockIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
);
const ListIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/>
        <line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
    </svg>
);

const formatarData = (dataString) => {
    if (!dataString) return 'Data não informada';
    try {
        const [ano, mes, dia] = dataString.split('T')[0].split('-').map(Number);
        const meses = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
        const dias = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];
        const dt = new Date(ano, mes - 1, dia);
        return `${dias[dt.getDay()]}, ${dia} ${meses[mes - 1]} ${ano}`;
    } catch { return 'Data inválida'; }
};

const EventoAtivoCard = ({ evento }) => (
    <>
        <style>{`
            @keyframes eac-dot { 0%,100%{transform:scale(1);opacity:1;} 50%{transform:scale(.7);opacity:.4;} }
            @keyframes eac-glow {
                0%,100% { box-shadow: 0 2px 16px rgba(44,203,144,0.12), 0 1px 4px rgba(44,203,144,0.06); }
                50%     { box-shadow: 0 4px 24px rgba(44,203,144,0.22), 0 2px 8px rgba(44,203,144,0.1); }
            }
        `}</style>
        <div style={{
            background: 'linear-gradient(135deg, #f0fdf8 0%, #f8fffc 100%)',
            border: '1px solid rgba(44,203,144,0.25)',
            borderLeft: '4px solid #2CCB90',
            borderRadius: '14px',
            padding: '20px',
            fontFamily: "'Inter', -apple-system, sans-serif",
            animation: 'eac-glow 3s ease-in-out infinite',
        }}>
            {/* Badge ao vivo */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '4px 12px', borderRadius: '100px', background: '#2CCB90', color: '#fff', fontSize: '11px', fontWeight: 700, letterSpacing: '0.05em', boxShadow: '0 2px 8px rgba(44,203,144,0.35)' }}>
                    <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#fff', animation: 'eac-dot 1.2s ease-in-out infinite', flexShrink: 0 }} />
                    EVENTO EM ANDAMENTO
                </span>
            </div>

            {/* Título */}
            <h2 style={{ margin: '0 0 14px', fontSize: 'clamp(18px,3vw,24px)', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.02em', lineHeight: 1.2 }}>
                {evento.titulo}
            </h2>

            {/* Meta */}
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '5px 12px', borderRadius: '8px', background: 'rgba(139,92,246,0.08)', border: '1px solid rgba(139,92,246,0.18)', color: '#7c3aed', fontSize: '12px', fontWeight: 600 }}>
                    <CalendarIcon /> {formatarData(evento.data)}
                </span>
                {evento.hora_inicio_real && (
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '5px 12px', borderRadius: '8px', background: 'rgba(44,203,144,0.08)', border: '1px solid rgba(44,203,144,0.2)', color: '#16a972', fontSize: '12px', fontWeight: 600 }}>
                        <ClockIcon /> Iniciado: {evento.hora_inicio_real}
                    </span>
                )}
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '5px 12px', borderRadius: '8px', background: 'rgba(37,99,235,0.06)', border: '1px solid rgba(37,99,235,0.15)', color: '#2563eb', fontSize: '12px', fontWeight: 600 }}>
                    <ListIcon /> {evento.tarefas?.length || 0} tarefas
                </span>
            </div>
        </div>
    </>
);

export default EventoAtivoCard;
